<template>
  <div class="weight-loss-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">
        Control de Peso / Reducción de Grasa No Quirúrgica
      </h2>
      <p>
        En Diverse Care Now, ofrecemos programas de pérdida de peso supervisados
        médicamente, que combinan medicación moderna con apoyo en el estilo de
        vida. El objetivo no es solo bajar de peso — es lograr salud duradera,
        equilibrio y confianza.
      </p>
      <h3>Lo que incluimos</h3>
      <ul>
        <li>
          Opciones de medicación — Terapias de medicación supervisadas por médicos,
          recetadas cuando corresponde y siempre bajo supervisión
          médica.
        </li>
        <li>
          Planes personalizados — cada paciente recibe un programa adaptado a su
          historial de salud, metas y necesidades individuales.
        </li>
        <li>
          Nutrición & apoyo en el estilo de vida — orientación en planificación
          de comidas, control de porciones y hábitos saludables.
        </li>
        <li>
          Monitoreo continuo — consultas mensuales y ajustes de dosis para
          garantizar seguridad y eficacia.
        </li>
      </ul>
      <p>
        "Más que perder peso, nuestros programas están diseñados para restaurar
        su salud, energía y autoconfianza — siempre con acompañamiento médico
        especializado."
      </p>
    </div>
    <div class="wl-videos">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 1.5rem;
        "
        src="https://www.youtube.com/embed/L1P7TDXi-3g"
        title="YouTube Shorts: Weight Loss 1"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/VVgrgvhakKY"
        title="YouTube Shorts: Weight Loss 2"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeightLossContentEs",
};
</script>

<style scoped>
.weight-loss-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.wl-videos {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.wl-videos iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .weight-loss-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .wl-videos {
    align-self: center;
  }

  .wl-videos iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .wl-videos iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
